import React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { SettingsLayout } from '../../components/Pleri/components/Settings/SettingsLayout';
import { MemoryTab } from '../../components/Pleri/components/Memory/MemoryTab';

export const Route = createFileRoute('/settings/')({
  component: RouteComponent,
  beforeLoad: () => {
    // Redirect to preferences by default
    throw redirect({
      to: '/settings/preferences',
    });
  },
});

function RouteComponent() {
  return (
    <SettingsLayout>
      <MemoryTab />
    </SettingsLayout>
  );
}
